// frontend/src/contexts/LanguageContext.js
import React, { createContext, useContext, useState } from "react";
import Cookies from "js-cookie";

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error("useLanguage must be used within a LanguageProvider");
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    // 1. Check for saved preference
    const savedLanguage = Cookies.get("academy_language");
    if (savedLanguage) {
      console.log(`Using saved language preference: ${savedLanguage}`);
      return savedLanguage;
    }
    
    // 2. Check browser language
    const browserLang = navigator.language || navigator.languages?.[0] || 'en';
    console.log(`Browser language detected: ${browserLang}`);
    
    // 3. If German-speaking browser, use German
    if (browserLang.toLowerCase().startsWith('de')) {
      console.log('German browser detected, defaulting to German');
      return 'de';
    }
    
    // 4. Default to English for all other languages
    console.log('Non-German browser detected, defaulting to English');
    return 'en';
  });

  const changeLanguage = (newLanguage) => {
    setLanguage(newLanguage);
    Cookies.set("academy_language", newLanguage, { expires: 365 });
  };

  const t = (textObj) => {
    if (typeof textObj === "string") return textObj;
    if (!textObj) return "";
    return textObj[language] || textObj.en || "";
  };

  const value = {
    language,
    changeLanguage,
    t,
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};
